export * from './SearchOutletCard';
export { type SearchOutletCardProps } from './SearchOutletCard.types';
